import { Component, OnInit } from '@angular/core';
import { AdminGuard } from '../../gaurds/admin.guard';
import { ResumeGuard } from '../../gaurds/resume.guard';
import { LocalizationService } from '../../services/localization/localization.service';
import { AuthService } from '../../services/auth/auth.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {

  isAdmin!: boolean;
  isResumeAdmin!: boolean;
  Username: string = '';
  isRtl: boolean = false;
  isLogin!: boolean;

  constructor(private adminGuard: AdminGuard, private resumeGuard: ResumeGuard, private localization: LocalizationService, private authService: AuthService) { }

  ngOnInit(): void {
    if(this.adminGuard.isAdmin()){this.isAdmin = true;}
    else {this.isAdmin = false}

    if(this.resumeGuard.isResumeAdmin()){this.isResumeAdmin = true;}
    else {this.isResumeAdmin = false}

    this.Username = localStorage.getItem('Username')!;

    if (this.localization.isRtl()) {
      this.isRtl = true
    } else {this.isRtl = false}

    if (this.authService.IsSignIn()) {
      this.isLogin = true;
    }
  }


  logout() {
    this.authService.logout();
  }
}
